import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import keycloak from './Keycloak';

function App() {
    const [activeTab, setActiveTab] = useState('app1');
    const [input1, setInput1] = useState('');
    const [results1, setResults1] = useState([]);
    const [loading1, setLoading1] = useState(false);
    const [progress1, setProgress1] = useState(0);

    const [productCodes, setProductCodes] = useState('');
    const [results2, setResults2] = useState([]);
    const [loading2, setLoading2] = useState(false);
    const [progress2, setProgress2] = useState(0);

    const [categoryPxl, setCategoryPxl] = useState('');
    const [results3, setResults3] = useState([]);
    const [loading3, setLoading3] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState({});
    const [optimizingProducts, setOptimizingProducts] = useState({});

    const [input4, setInput4] = useState('');
    const [loading4, setLoading4] = useState(false);
    const [progress4, setProgress4] = useState(0);
    const [results4, setResults4] = useState([]);

    const [categoryModifications, setCategoryModifications] = useState([]);
    const [loadingCategoryMods, setLoadingCategoryMods] = useState(false);
    const [processingCategory, setProcessingCategory] = useState(null);

    // State variables for the popup
    const [showPopup, setShowPopup] = useState(false);
    const [currentPxlCode, setCurrentPxlCode] = useState('');
    const [zpCodeInput, setZpCodeInput] = useState('');

    // State for Translate Product Name (TPN) modal
    const [showTPNModal, setShowTPNModal] = useState(false);
    const [tpnLoading, setTpnLoading] = useState(false);
    const [tpnError, setTpnError] = useState('');
    const [tpnNameNl, setTpnNameNl] = useState('');
    const [tpnZapCode, setTpnZapCode] = useState('');
    const [tpnPxlCode, setTpnPxlCode] = useState('');
    const [tpnTranslations, setTpnTranslations] = useState({});
    const [tpnSaving, setTpnSaving] = useState(false);
    const [tpnSaveError, setTpnSaveError] = useState('');
    const [tpnSaveSuccess, setTpnSaveSuccess] = useState('');
    const [tpnCurrentNames, setTpnCurrentNames] = useState({});

    // State for Translate Product Description (TPD) modal
    const [showTPDModal, setShowTPDModal] = useState(false);
    const [tpdLoading, setTpdLoading] = useState(false);
    const [tpdError, setTpdError] = useState('');
    const [tpdDescNl, setTpdDescNl] = useState('');
    const [tpdZapCode, setTpdZapCode] = useState('');
    const [tpdPxlCode, setTpdPxlCode] = useState('');
    const [tpdTranslations, setTpdTranslations] = useState({});
    const [tpdSaving, setTpdSaving] = useState(false);
    const [tpdSaveError, setTpdSaveError] = useState('');
    const [tpdSaveSuccess, setTpdSaveSuccess] = useState('');
    const [tpdCurrentDescriptions, setTpdCurrentDescriptions] = useState({});

    // State variables for category matches administration
    const [categoryMatches, setCategoryMatches] = useState([]);
    const [loadingCategoryMatches, setLoadingCategoryMatches] = useState(false);
    const [newPxlCode, setNewPxlCode] = useState('');
    const [newZpCode, setNewZpCode] = useState('');
    const [editingMatch, setEditingMatch] = useState(null);

    // State variables for price modifications
    const [priceModifications, setPriceModifications] = useState([]);
    const [loadingPriceModifications, setLoadingPriceModifications] = useState(false);
    
    // State variables for catalog picture modifications
    const [catalogPicModifications, setCatalogPicModifications] = useState([]);
    const [loadingCatalogPicModifications, setLoadingCatalogPicModifications] = useState(false);
    
    // State variables for base URLs
    const [baseUrls, setBaseUrls] = useState({
        compuzzUrl: 'https://dashboard.compuzz.com',
        promoxlUrl: 'https://promoxl.compuzz.com',
        zaprintaUrl: 'https://zaprinta.compuzz.com'
    });
    
    // State variables for secId fetching
    const [loadingSecId, setLoadingSecId] = useState(false);
    const [secIdCache, setSecIdCache] = useState({});

    // Auto-submit flag for Copy Products from Category when navigated from Category Mods
    const [autoSubmittedCategory, setAutoSubmittedCategory] = useState(false);

    // ZAP Name language selection for App3
    const [zapNameLang, setZapNameLang] = useState('nl');

    // Highlight selected row in results (last treated)
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    // State variables for CSV upload
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [uploadResults, setUploadResults] = useState(null);

    // State variables for Optimize Product v2 tab
    const [productCodes2, setProductCodes2] = useState('');
    const [results2v2, setResults2v2] = useState([]);
    const [loading2v2, setLoading2v2] = useState(false);
    const [progress2v2, setProgress2v2] = useState(0);

    // State variables for Copy Category tab
    const [copyCategoryInput, setCopyCategoryInput] = useState('');
    const [copyCategoryResults, setCopyCategoryResults] = useState([]);
    const [copyCategoryLoading, setCopyCategoryLoading] = useState(false);
    const [copyCategoryProgress, setCopyCategoryProgress] = useState(0);

    // Function to fetch base URLs
    const fetchBaseUrls = async () => {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get('api/base-urls', { headers });
            setBaseUrls(response.data);
        } catch (error) {
            console.error('Error fetching base URLs:', error);
            // Keep default values if there's an error
        }
    };
    
    // Function to fetch secId for a specific product code
    const fetchSecId = async (type, code) => {
        // Check if we already have this secId in cache
        const cacheKey = `${type}-${code}`;
        if (secIdCache[cacheKey]) {
            return secIdCache[cacheKey];
        }
        
        setLoadingSecId(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get(`api/product-secid/${type}/${code}`, { headers });
            
            if (response.data && response.data.secId) {
                // Update cache - only cache the secId, not the pim property
                setSecIdCache(prev => ({
                    ...prev,
                    [cacheKey]: { secId: response.data.secId, pim: response.data.pim }
                }));
                // Return both secId and pim property
                return {
                    secId: response.data.secId,
                    pim: response.data.pim
                };
            }
            return null;
        } catch (error) {
            console.error(`Error fetching secId for ${type} product ${code}:`, error);
            return null;
        } finally {
            setLoadingSecId(false);
        }
    };
    
    // Function to handle product link click in price modifications screen (with secId fetching)
    const handleProductLinkClick = async (e, type, code, fallbackId) => {
        e.preventDefault();
        
        // Determine base URL
        let baseUrl;
        if (type === 'pxl') {
            baseUrl = baseUrls.promoxlUrl;
        } else if (type === 'zp') {
            baseUrl = baseUrls.zaprintaUrl;
        } else {
            console.error('Invalid product type');
            return;
        }
        
        // Try to fetch secId and pim property
        const result = await fetchSecId(type, code);
        
        // Construct URL
        let url;
        if (result) {
            // Check if pim property is false
            if (result.pim === false) {
                // Use #product/{secId} format
                url = `${baseUrl}/#product/${result.secId}/prices`;
            } else {
                // Use #pim/products/{secId}/prices format
                url = `${baseUrl}/#pim/products/${result.secId}/prices`;
            }
        } else {
            url = `${baseUrl}/#webshop/products/${fallbackId}`;
        }
        
        // Open URL in new tab
        window.open(url, '_blank');
    };
    
    // Function to handle product link click in copy products screen (without secId fetching)
    const handleCopyProductsLinkClick = (e, type, code, fallbackId) => {
        e.preventDefault();
        
        // Determine base URL
        let baseUrl;
        if (type === 'pxl') {
            baseUrl = baseUrls.promoxlUrl;
        } else if (type === 'zp') {
            baseUrl = baseUrls.zaprintaUrl;
        } else {
            console.error('Invalid product type');
            return;
        }
        
        // Construct URL using the fallback ID directly (previous approach)
        const url = `${baseUrl}/#webshop/products/${fallbackId}`;
        
        // Open URL in new tab
        window.open(url, '_blank');
    };

    // Function to fetch category modification dates
    const fetchCategoryModifications = async () => {
        setLoadingCategoryMods(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get('api/category-last-modification', { headers });
            setCategoryModifications(response.data);
        } catch (error) {
            console.error('Error fetching category modifications:', error);
        } finally {
            setLoadingCategoryMods(false);
        }
    };
    
    // Function to fetch price modifications
    const fetchPriceModifications = async () => {
        setLoadingPriceModifications(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get('api/price-modifications', { headers });
            setPriceModifications(response.data);
        } catch (error) {
            console.error('Error fetching price modifications:', error);
        } finally {
            setLoadingPriceModifications(false);
        }
    };
    
    // Function to fetch catalog picture modifications
    const fetchCatalogPicModifications = async () => {
        setLoadingCatalogPicModifications(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get('api/catalog-picture-modifications', { headers });
            setCatalogPicModifications(response.data);
        } catch (error) {
            console.error('Error fetching catalog picture modifications:', error);
        } finally {
            setLoadingCatalogPicModifications(false);
        }
    };

    // Function to handle the "Add" button click
    const handleAddCategoryMatch = async (pxl_code) => {
        setProcessingCategory(pxl_code);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.post('api/check-category-match', { pxl_code }, { headers });

            // If zp_code exists, switch to the "Copy Products from Category" tab
            if (response.data.exists && response.data.zp_code) {
                setActiveTab('app3');
                setCategoryPxl(`${response.data.pxl_code},${response.data.zp_code}`);
            } else {
                // If zp_code doesn't exist, show the popup to enter it
                setCurrentPxlCode(pxl_code);
                setZpCodeInput('');
                setShowPopup(true);
            }
        } catch (error) {
            console.error('Error checking category match:', error);
        } finally {
            setProcessingCategory(null);
        }
    };

    // Function to handle the "Add (New Tab)" action
    const handleAddCategoryMatchNewTab = (pxl_code) => {
        try {
            const base = window.location.origin + window.location.pathname;
            const url = `${base}?addCategory=${encodeURIComponent(pxl_code)}`;
            window.open(url, '_blank', 'noopener');
        } catch (e) {
            console.error('Error opening new tab for category add:', e);
        }
    };

    // Function to handle saving the zp_code
    const handleSaveZpCode = async () => {
        if (!zpCodeInput.trim()) {
            alert('Please enter a Zaprinta code');
            return;
        }

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };

            // Update the zp_code in the database
            await axios.post('api/update-category-match', { 
                pxl_code: currentPxlCode, 
                zp_code: zpCodeInput.trim() 
            }, { headers });

            // Close the popup
            setShowPopup(false);

            // Switch to the "Copy Products from Category" tab
            setActiveTab('app3');
            setCategoryPxl(`${currentPxlCode},${zpCodeInput.trim()}`);

            // Refresh the category modifications list
            if (activeTab === 'categoryMods') {
                fetchCategoryModifications();
            }
        } catch (error) {
            console.error('Error updating category match:', error);
            alert('Error updating Zaprinta code. Please try again.');
        }
    };

    // Function to fetch all category matches
    const fetchCategoryMatches = async () => {
        setLoadingCategoryMatches(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };
            const response = await axios.get('api/category-matches', { headers });
            setCategoryMatches(response.data);
        } catch (error) {
            console.error('Error fetching category matches:', error);
        } finally {
            setLoadingCategoryMatches(false);
        }
    };

    // Function to add a new category match
    const handleAddCategoryMatch2 = async () => {
        if (!newPxlCode.trim()) {
            alert('Please enter a PXL code');
            return;
        }

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };

            // Check if the pxl_code already exists
            const response = await axios.post('api/check-category-match', { 
                pxl_code: newPxlCode.trim() 
            }, { headers });

            // If zp_code is provided, update it
            if (newZpCode.trim()) {
                await axios.post('api/update-category-match', { 
                    pxl_code: newPxlCode.trim(), 
                    zp_code: newZpCode.trim() 
                }, { headers });
            }

            // Clear the form
            setNewPxlCode('');
            setNewZpCode('');

            // Refresh the category matches list
            fetchCategoryMatches();
        } catch (error) {
            console.error('Error adding category match:', error);
            alert('Error adding category match. Please try again.');
        }
    };

    // Function to update a category match
    const handleUpdateCategoryMatch = async (pxl_code, zp_code) => {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };

            await axios.post('api/update-category-match', { 
                pxl_code, 
                zp_code 
            }, { headers });

            // Clear the editing state
            setEditingMatch(null);

            // Refresh the category matches list
            fetchCategoryMatches();
        } catch (error) {
            console.error('Error updating category match:', error);
            alert('Error updating category match. Please try again.');
        }
    };

    // Function to delete a category match
    const handleDeleteCategoryMatch = async (pxl_code) => {
        if (!window.confirm(`Are you sure you want to delete the match for ${pxl_code}?`)) {
            return;
        }

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${keycloak.token}`,
            };

            await axios.delete(`api/category-match/${pxl_code}`, { headers });

            // Refresh the category matches list
            fetchCategoryMatches();
        } catch (error) {
            console.error('Error deleting category match:', error);
            alert('Error deleting category match. Please try again.');
        }
    };

    // Function to handle file selection
    const handleFileSelect = (event) => {
        setSelectedFile(event.target.files[0]);
        setUploadResults(null); // Clear previous results
    };

    // Function to handle file upload
    const handleFileUpload = async () => {
        if (!selectedFile) {
            alert('Please select a CSV file to upload');
            return;
        }

        // Check if the file is a CSV
        if (!selectedFile.name.endsWith('.csv') && selectedFile.type !== 'text/csv') {
            alert('Please select a CSV file');
            return;
        }

        setUploadingFile(true);
        setUploadProgress(0);
        setUploadResults(null);

        try {
            const formData = new FormData();
            formData.append('file', selectedFile);

            const headers = {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${keycloak.token}`,
            };

            const response = await axios.post('api/upload-category-matches', formData, {
                headers,
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                }
            });

            setUploadResults(response.data);

            // Refresh the category matches list
            fetchCategoryMatches();

            // Clear the file input
            setSelectedFile(null);

            // Reset the file input element
            const fileInput = document.getElementById('csv-file-input');
            if (fileInput) {
                fileInput.value = '';
            }
        } catch (error) {
            console.error('Error uploading CSV file:', error);
            setUploadResults({
                success: false,
                error: error.response?.data?.error || 'Error uploading CSV file. Please try again.'
            });
        } finally {
            setUploadingFile(false);
        }
    };

    // Function to handle downloading category matches as CSV
    const handleDownloadCategoryMatches = async () => {
        try {
            const headers = {
                'Authorization': `Bearer ${keycloak.token}`,
            };

            // Use axios to make the request with the proper headers
            const response = await axios.get('api/download-category-matches', {
                headers,
                responseType: 'blob', // Important for handling the file download
            });

            // Create a blob URL and trigger the download
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'category-matches.csv');
            document.body.appendChild(link);
            link.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading category matches:', error);
            alert('Error downloading category matches. Please try again.');
        }
    };

    // Fetch base URLs when component mounts
    useEffect(() => {
        fetchBaseUrls();
    }, []);

    // Load data when the tab is selected
    useEffect(() => {
        if (activeTab === 'categoryMods') {
            fetchCategoryModifications();
        } else if (activeTab === 'categoryMatches') {
            fetchCategoryMatches();
        } else if (activeTab === 'priceModifications') {
            fetchPriceModifications();
        } else if (activeTab === 'catalogPicModifications') {
            fetchCatalogPicModifications();
        }
    }, [activeTab]);

    // Handle submit for App 1
    const handleApp1Submit = async () => {
        const lines = input1.split('\n').filter((line) => line.trim() !== '');
        setLoading1(true);
        setProgress1(0);
        setResults1([]);

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const [supplier, supplierKode] = line.split(',');
            if (supplier && supplierKode) {
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ` + keycloak.token, // Replace with your token
                    };
                    const response = await axios.post('api/fetch-data', {
                        supplier: supplier.trim(),
                        supplierKode: supplierKode.trim(),
                    }, { headers });
                    setResults1(prev => [...prev, { supplier, supplierKode, status: response.data.status }]);
                } catch (error) {
                    setResults1(prev => [...prev, { supplier, supplierKode, status: 'Error' }]);
                }
            }
            setProgress1(((i + 1) / lines.length) * 100);
        }
        setLoading1(false);
    };// Handle submit for App 1

    const processCategory = async () => {
        const lines = input4.split('\n').filter((line) => line.trim() !== '');
        setLoading4(true);
        setProgress4(0);
        setResults4([]);

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const [categoryCode, keywords, locale, skipIfDone] = line.split(',');
            if (categoryCode && keywords && locale) {
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ` + keycloak.token, // Replace with your token
                    };
                    const response = await axios.post('api/processCategory', {
                        categoryCode: categoryCode.trim(),
                        keyWords: keywords.trim(),
                        locale: locale?locale.trim():null,
                        skipIfDone: skipIfDone?skipIfDone.trim():false,
                    }, { headers });
                    setResults4(prev => [...prev, { categoryCode, keywords, score: response.data.score, url: response.data.url }]);
                } catch (error) {
                    setResults4(prev => [...prev, { categoryCode, keywords, status: 'Error' }]);
                }
            }
            setProgress4(((i + 1) / lines.length) * 100);
        }
        setLoading4(false);
    };

    // Handle submit for App 2
    const optimizeProduct = async () => {
        const codesArray = productCodes.split('\n').filter((code) => code.trim() !== '');
        setLoading2(true);
        setProgress2(0);
        setResults2([]); // Clear previous results

        for (let i = 0; i < codesArray.length; i++) {
            const [code, lang] = codesArray[i].split(',');
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ` + keycloak.token, // Replace with your token
                };
                const response = await axios.post('process', { productCode: code, lang: lang }, { headers });
                const newResult = response.data[0]; // Assuming server returns an array with a single result

                setResults2((prevResults) => [...prevResults, newResult]);
                setProgress2(((i + 1) / codesArray.length) * 100);
            } catch (error) {
                console.error('Error processing product code:', code, error);
            }
        }

        setLoading2(false);
    };

    // Handle submit for Optimize Product v2 (PXL NL name as translation base)
    const optimizeProduct2 = async () => {
        const codesArray = productCodes2.split('\n').filter((code) => code.trim() !== '');
        setLoading2v2(true);
        setProgress2v2(0);
        setResults2v2([]);

        for (let i = 0; i < codesArray.length; i++) {
            const code = codesArray[i].trim();
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${keycloak.token}`,
                };
                const response = await axios.post('process2', { productCode: code }, { headers });
                const newResult = response.data[0];
                setResults2v2((prev) => [...prev, newResult]);
            } catch (error) {
                console.error('Error processing product code (v2):', code, error);
                setResults2v2((prev) => [...prev, { productCode: code, translateStatus: 'Error: Request failed' }]);
            }
            setProgress2v2(((i + 1) / codesArray.length) * 100);
        }

        setLoading2v2(false);
    };

    // Handle submit for Copy Category tab
    const handleCopyCategorySubmit = async () => {
        const codesArray = copyCategoryInput.split('\n').filter((code) => code.trim() !== '');
        if (codesArray.length === 0) return;
        setCopyCategoryLoading(true);
        setCopyCategoryProgress(0);
        setCopyCategoryResults([]);

        for (let i = 0; i < codesArray.length; i++) {
            const code = codesArray[i].trim();
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${keycloak.token}`,
                };
                const response = await axios.post('api/copy-category', { productCode: code }, { headers });
                setCopyCategoryResults((prev) => [...prev, response.data]);
            } catch (error) {
                console.error('Error processing copy-category for code:', code, error);
                setCopyCategoryResults((prev) => [...prev, { productCode: code, status: 'Error: Request failed' }]);
            }
            setCopyCategoryProgress(((i + 1) / codesArray.length) * 100);
        }

        setCopyCategoryLoading(false);
    };

    const clickAddAllProductsInCategory = async (results3) => {
        setLoading3(true);
        var products = [];
        var zap_cat_code;
        for (var product of results3) {
            if (product.zap_cat_code) {
                zap_cat_code = product.zap_cat_code;
            }
            if (product.zap_code) {
                products.push({code: product.zap_code, position: product.pos});
            }
        }
        setResults3([]);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token, // Replace with your token
            };
            await axios.post('api/add-all-products-in-category-zaprinta', {
                zap_cat_code: zap_cat_code,
                products: products
            }, { headers });
        } catch (error) {
            console.error('Error processing category:', zap_cat_code, error);
            try {
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || (error && error.data && error.data.message)
                    || (error && error.message)
                    || 'An unexpected error occurred while adding products to the category.';
                alert(msg);
            } catch (e) {
                // Fallback in case accessing error properties fails
                alert('An unexpected error occurred while adding products to the category.');
            }
        } finally {
            setLoading3(false);
            await handleCopyProductFromCategorySubmit();
        }
    }

    const clickAddProductInCategory = async (zap_code, zap_cat_code, pos, first) => {
        var results3Bak = results3;
        setLoading3(true);
        setResults3([]);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token, // Replace with your token
            };
            await axios.post('api/add-product-in-category-zaprinta', {
                zap_code: zap_code,
                zap_cat_code: zap_cat_code,
                pos: pos,
                first: first
            }, { headers });
        } catch (error) {
            console.error('Error processing category:', zap_code, error);
        } finally {
            setLoading3(false);
            setResults3(results3Bak);
        }
    }
    
    const addProductToWebshop = async (supplier, supplierCode) => {
        const productKey = `${supplier}-${supplierCode}`;
        setLoadingProducts(prev => ({ ...prev, [productKey]: true }));
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            const response = await axios.post('api/fetch-data', {
                supplier: supplier.trim(),
                supplierKode: supplierCode.trim(),
            }, { headers });
            
            // Check for success status codes (200 or 204)
            if (response.status === 200 || response.status === 204) {
                alert(`Product ${supplierCode} from ${supplier} added successfully`);
            } else {
                alert(`Product ${supplierCode} from ${supplier} status: ${response.data.status}`);
            }
        } catch (error) {
            console.error('Error adding product to webshop:', supplier, supplierCode, error);
            alert(`Error adding product ${supplierCode} from ${supplier} to webshop`);
        } finally {
            setLoadingProducts(prev => ({ ...prev, [productKey]: false }));
        }
    }
    
    const optimizeSingleProduct = async (code, lang = null) => {
        const productKey = code;
        setOptimizingProducts(prev => ({ ...prev, [productKey]: true }));
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            const response = await axios.post('process', { 
                productCode: code, 
                lang: lang 
            }, { headers });
            
            if (response.data && response.data.length > 0) {
                const result = response.data[0];
                alert(`Product ${code} optimized successfully. Category: ${result.categoryName}`);
                // Refresh the products list to show updated status
                await handleCopyProductFromCategorySubmit();
            } else {
                alert(`Failed to optimize product ${code}`);
            }
        } catch (error) {
            console.error('Error optimizing product:', code, error);
            alert(`Error optimizing product ${code}`);
        } finally {
            setOptimizingProducts(prev => ({ ...prev, [productKey]: false }));
        }
    }

    // TPN: open modal and fetch translations
    const openTPNModal = async (result, index = null) => {
        if (typeof index === 'number') {
            setSelectedRowIndex(index);
            setTimeout(() => {
                const el = document.getElementById(`app3-row-${index}`);
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 0);
        }
        try {
            setTpnError('');
            setTpnTranslations({});
            setTpnCurrentNames({});
            setTpnSaveError('');
            setTpnSaveSuccess('');
            const nlName = result?.namenl || '';
            const zapCode = result?.zap_code || '';
            const pxlCode = result?.code || '';
            setTpnNameNl(nlName);
            setTpnZapCode(zapCode);
            setTpnPxlCode(pxlCode);
            setShowTPNModal(true);
            if (!nlName && !zapCode) return;
            setTpnLoading(true);
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            const requests = [];
            if (nlName) {
                requests.push(axios.post('api/translate-product-name', { name: nlName }, { headers }));
            } else {
                requests.push(Promise.resolve(null));
            }
            if (zapCode) {
                requests.push(axios.get(`api/get-product?code=${encodeURIComponent(zapCode)}`, { headers }));
            } else {
                requests.push(Promise.resolve(null));
            }
            const [respTranslate, respProduct] = await Promise.all(requests);
            if (respTranslate && respTranslate.data) {
                setTpnTranslations(respTranslate.data?.translations || {});
            }
            if (respProduct && respProduct.data) {
                const nameArr = Array.isArray(respProduct.data.name) ? respProduct.data.name : [];
                const current = {};
                nameArr.forEach(item => {
                    if (item && item.language && typeof item.name === 'string') {
                        current[item.language] = item.name;
                    }
                });
                setTpnCurrentNames(current);
            }
        } catch (e) {
            console.error('TPN error:', e);
            setTpnError('Failed to fetch translations');
        } finally {
            setTpnLoading(false);
        }
    };

    const saveTPNTranslations = async () => {
        try {
            setTpnSaveError('');
            setTpnSaveSuccess('');
            setTpnSaving(true);
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            // Send translations and the Zaprinta product code
            await axios.post('api/update-product-names', { translations: tpnTranslations, code: tpnZapCode }, { headers });
            setTpnSaveSuccess('Translations saved successfully.');
        } catch (e) {
            console.error('TPN save error:', e);
            const msg = e?.response?.data?.error || e?.message || 'Failed to save translations';
            setTpnSaveError(msg);
        } finally {
            setTpnSaving(false);
        }
    };

    const handleCloseTPNModal = () => {
        setShowTPNModal(false);
        setTpnSaveSuccess('');
        setTpnSaveError('');
        setTpnPxlCode('');
    };

    // Re-translate product name when NL source changes (debounced)
    useEffect(() => {
        if (!showTPNModal) return;
        const val = (tpnNameNl || '').trim();
        if (!val) {
            setTpnTranslations({});
            return;
        }
        setTpnError('');
        setTpnLoading(true);
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ` + keycloak.token,
                };
                const resp = await axios.post('api/translate-product-name', { name: val }, { headers });
                if (!cancelled) {
                    setTpnTranslations(resp.data?.translations || {});
                }
            } catch (e) {
                if (!cancelled) setTpnError('Failed to fetch translations');
            } finally {
                if (!cancelled) setTpnLoading(false);
            }
        }, 500);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [tpnNameNl, showTPNModal]);

    // TPD: open modal and fetch translations
    const openTPDModal = async (result, index = null) => {
        if (typeof index === 'number') {
            setSelectedRowIndex(index);
            setTimeout(() => {
                const el = document.getElementById(`app3-row-${index}`);
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 0);
        }
        try {
            setTpdError('');
            setTpdTranslations({});
            setTpdCurrentDescriptions({});
            setTpdSaveError('');
            setTpdSaveSuccess('');
            const nlDesc = result?.descriptionnl || '';
            const zapCode = result?.zap_code || '';
            const pxlCode = result?.code || '';
            setTpdDescNl(nlDesc);
            setTpdZapCode(zapCode);
            setTpdPxlCode(pxlCode);
            setShowTPDModal(true);
            if (!nlDesc && !zapCode) return;
            setTpdLoading(true);
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            const requests = [];
            if (nlDesc) {
                requests.push(axios.post('api/translate-product-description', { description: nlDesc }, { headers }));
            } else {
                requests.push(Promise.resolve(null));
            }
            if (zapCode) {
                requests.push(axios.get(`api/get-product?code=${encodeURIComponent(zapCode)}`, { headers }));
            } else {
                requests.push(Promise.resolve(null));
            }
            const [respTranslate, respProduct] = await Promise.all(requests);
            if (respTranslate && respTranslate.data) {
                setTpdTranslations(respTranslate.data?.translations || {});
            }
            if (respProduct && respProduct.data) {
                const descArr = Array.isArray(respProduct.data.description) ? respProduct.data.description : [];
                const current = {};
                descArr.forEach(item => {
                    if (item && item.language && typeof item.description === 'string') {
                        current[item.language] = item.description;
                    }
                });
                setTpdCurrentDescriptions(current);
            }
        } catch (e) {
            console.error('TPD error:', e);
            setTpdError('Failed to fetch translations');
        } finally {
            setTpdLoading(false);
        }
    };

    const saveTPDTranslations = async () => {
        try {
            setTpdSaveError('');
            setTpdSaveSuccess('');
            setTpdSaving(true);
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token,
            };
            await axios.post('api/update-product-descriptions', { translations: tpdTranslations, code: tpdZapCode }, { headers });
            setTpdSaveSuccess('Translations saved successfully.');
        } catch (e) {
            console.error('TPD save error:', e);
            const msg = e?.response?.data?.error || e?.message || 'Failed to save translations';
            setTpdSaveError(msg);
        } finally {
            setTpdSaving(false);
        }
    };

    const handleCloseTPDModal = () => {
        setShowTPDModal(false);
        setTpdSaveSuccess('');
        setTpdSaveError('');
        setTpdPxlCode('');
    };

    // Re-translate product description when NL source changes (debounced)
    useEffect(() => {
        if (!showTPDModal) return;
        const val = (tpdDescNl || '').trim();
        if (!val) {
            setTpdTranslations({});
            return;
        }
        setTpdError('');
        setTpdLoading(true);
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ` + keycloak.token,
                };
                const resp = await axios.post('api/translate-product-description', { description: val }, { headers });
                if (!cancelled) {
                    setTpdTranslations(resp.data?.translations || {});
                }
            } catch (e) {
                if (!cancelled) setTpdError('Failed to fetch translations');
            } finally {
                if (!cancelled) setTpdLoading(false);
            }
        }, 500);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [tpdDescNl, showTPDModal]);

    // Handle submit for App 3 (New Functionality)
    const handleCopyProductFromCategorySubmit = async () => {
        setLoading3(true);
        setResults3([]);

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + keycloak.token, // Replace with your token
            };
            var categoryPxlZaprinta = categoryPxl.trim().split(',');
            const response = await axios.post('api/copy-products-from-category', {
                categoryPxl: categoryPxlZaprinta[0],
                categoryZaprinta: categoryPxlZaprinta[1],
            }, { headers });
            setResults3(response.data);
        } catch (error) {
            console.error('Error processing category:', categoryPxl, error);
        } finally {
            setLoading3(false);
        }
    };

    // Auto-submit when arriving on Copy Products from Category with pre-filled pair
    useEffect(() => {
        // Reset flag on category change so a new pair can auto-submit
        setAutoSubmittedCategory(false);
    }, [categoryPxl]);

    useEffect(() => {
        const hasPair = typeof categoryPxl === 'string' && categoryPxl.includes(',');
        if (activeTab === 'app3' && hasPair && !loading3 && !autoSubmittedCategory) {
            setAutoSubmittedCategory(true);
            handleCopyProductFromCategorySubmit();
        }
    }, [activeTab, categoryPxl, loading3, results3, autoSubmittedCategory]);

    // Deep-link handler: if URL includes ?addCategory=CODE, perform same action as "Add"
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('addCategory');
        if (code) {
            handleAddCategoryMatch(code);
            // Clean the URL to avoid re-trigger if user navigates
            const cleanedUrl = window.location.origin + window.location.pathname + window.location.hash;
            try {
                window.history.replaceState({}, '', cleanedUrl);
            } catch (e) {
                // ignore if browser blocks
            }
        }
        // run once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Function to handle copying the results to clipboard
    const handleCopyResults = () => {
        let copyText = 'ZAP Code + Position\n';

        results3.forEach(result => {
            copyText += `${result.zap_code || 'N/A'},${result.pos}\n`;
        });

        navigator.clipboard.writeText(copyText).then(() => {
            alert('Results copied to clipboard!');
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };
    
    // Helper to build full image URL from base and link
    const buildFullImageUrl = (base, link) => {
        if (!link) return null;
        if (/^https?:\/\//i.test(link)) return link;
        const trimmedBase = base.replace(/\/+$/, '');
        const trimmedLink = String(link).replace(/^\/+/, '');
        return `${trimmedBase}/${trimmedLink}`;
    };
    
    // Helper to get ZAP name by selected language
    const getZapNameByLang = (item) => {
        const map = {
            fr: item.zap_namefr,
            nl: item.zap_namenl,
            de: item.zap_namede,
            es: item.zap_namees,
            it: item.zap_nameit,
            en: item.zap_nameen,
            da: item.zap_nameda,
        };
        return map[zapNameLang] || item.zap_namenl || item.zapName || item.zap_name || 'N/A';
    };

    // Reusable nice menu component for external links (no Bootstrap JS required)
    const LinkMenu = ({ label, subtitle, items }) => {
        const [open, setOpen] = React.useState(false);
        const menuRef = React.useRef(null);

        const toggle = () => setOpen(prev => !prev);
        const close = () => setOpen(false);

        React.useEffect(() => {
            const onClickOutside = (e) => {
                if (menuRef.current && !menuRef.current.contains(e.target)) {
                    close();
                }
            };
            const onKeyDown = (e) => {
                if (e.key === 'Escape') close();
            };
            document.addEventListener('mousedown', onClickOutside);
            document.addEventListener('keydown', onKeyDown);
            return () => {
                document.removeEventListener('mousedown', onClickOutside);
                document.removeEventListener('keydown', onKeyDown);
            };
        }, []);

        const handleItemClick = (url) => {
            if (url) window.open(url, '_blank', 'noreferrer');
            close();
        };

        return (
            <div className={`link-menu ${open ? 'open' : ''}`} ref={menuRef}>
                <button type="button" className="menu-button btn btn-outline-primary btn-sm" onClick={toggle}>
                    <span className="menu-label">{label}</span>
                    {subtitle ? <span className="menu-subtitle">{subtitle}</span> : null}
                    <span className="caret" aria-hidden>▾</span>
                </button>
                {open && (
                    <ul className="menu-list">
                        {items.map((it, idx) => (
                            <li key={idx}>
                                <button type="button" className="menu-item" onClick={() => handleItemClick(it.url)}>
                                    {it.icon ? <span className={`mi ${it.icon}`} aria-hidden></span> : null}
                                    <span>{it.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    };

    return (
        <div className="App container mt-5">
            {loadingSecId && (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p>Fetching product details...</p>
                    </div>
                </div>
            )}
            <div className="header">
                <img src="/compuzz-ai-logo.png" alt="Compuzz AI Logo" className="logo" />
            </div>
            <div className="tab-navigation">
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'app1' ? 'active' : ''}`}
                            onClick={() => setActiveTab('app1')}
                        >
                            Add Pim Products in Webshop
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'app2' ? 'active' : ''}`}
                            onClick={() => setActiveTab('app2')}
                        >
                            Optimize Products
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'app2v2' ? 'active' : ''}`}
                            onClick={() => setActiveTab('app2v2')}
                        >
                            Optimize Products v2
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'app3' ? 'active' : ''}`}
                            onClick={() => setActiveTab('app3')}
                        >
                            Copy Products from Category
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'category' ? 'active' : ''}`}
                            onClick={() => setActiveTab('category')}
                        >
                            Compute Category Description
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'categoryMods' ? 'active' : ''}`}
                            onClick={() => setActiveTab('categoryMods')}
                        >
                            Category Modification Dates
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'categoryMatches' ? 'active' : ''}`}
                            onClick={() => setActiveTab('categoryMatches')}
                        >
                            Category Matches
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'priceModifications' ? 'active' : ''}`}
                            onClick={() => setActiveTab('priceModifications')}
                        >
                            Price Modifications
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'catalogPicModifications' ? 'active' : ''}`}
                            onClick={() => setActiveTab('catalogPicModifications')}
                        >
                            Compuzz Cat Pic Mod
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'copyCategory' ? 'active' : ''}`}
                            onClick={() => setActiveTab('copyCategory')}
                        >
                            Copy Category
                        </button>
                    </li>
                </ul>
            </div>

            {showTPNModal && (
                <div className="tpn-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="tpn-modal" style={{ background: '#fff', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto' }}>
                        <h5 className="mb-3">Translate Product Name — ZAP: {tpnZapCode || 'N/A'} — PXL: {tpnPxlCode || 'N/A'}</h5>
                        <div className="form-group">
                            <label>NL (Promoxl)</label>
                            <input className="form-control" value={tpnNameNl} onChange={(e) => setTpnNameNl(e.target.value)} />
                        </div>
                        {tpnLoading && (
                            <div className="mb-2"><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading translations...</div>
                        )}
                        {tpnError && (
                            <div className="alert alert-danger">{tpnError}</div>
                        )}
                        {!tpnLoading && (
                            <>
                                {['fr','nl','de','es','it','en','da'].map((lang) => (
                                    <div className="form-group" key={lang}>
                                        <label>{lang.toUpperCase()}</label>
                                        <small className="form-text text-muted" style={{ display: 'block', textAlign: 'left', marginTop: '2px', marginBottom: '2px' }}>
                                            Current: {tpnCurrentNames[lang] || '—'}
                                        </small>
                                        <input
                                            className="form-control"
                                            value={tpnTranslations[lang] || ''}
                                            onChange={(e) => setTpnTranslations(prev => ({ ...prev, [lang]: e.target.value }))}
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                        {tpnSaveError && (
                            <div className="alert alert-danger mt-2">{tpnSaveError}</div>
                        )}
                        {tpnSaveSuccess && (
                            <div className="alert alert-success mt-2">{tpnSaveSuccess}</div>
                        )}
                        <div className="d-flex justify-content-end mt-3" style={{ gap: '8px' }}>
                            <button className="btn btn-primary" onClick={saveTPNTranslations} disabled={tpnSaving || tpnLoading}>
                                {tpnSaving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className="sr-only">Saving...</span>
                                    </>
                                ) : 'Save'}
                            </button>
                            <button className="btn btn-secondary" onClick={handleCloseTPNModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showTPDModal && (
                <div className="tpd-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="tpd-modal" style={{ background: '#fff', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '800px', maxHeight: '80vh', overflowY: 'auto' }}>
                        <h5 className="mb-3">Translate Product Description — ZAP: {tpdZapCode || 'N/A'} — PXL: {tpdPxlCode || 'N/A'}</h5>
                        <div className="form-group">
                            <label>NL (Promoxl) Description</label>
                            <textarea className="form-control" rows="4" value={tpdDescNl} onChange={(e) => setTpdDescNl(e.target.value)} />
                        </div>
                        {tpdLoading && (
                            <div className="mb-2"><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading translations...</div>
                        )}
                        {tpdError && (
                            <div className="alert alert-danger">{tpdError}</div>
                        )}
                        {!tpdLoading && (
                            <>
                                {['fr','nl','de','es','it','en','da'].map((lang) => (
                                    <div className="form-group" key={lang}>
                                        <label>{lang.toUpperCase()}</label>
                                        <small className="form-text text-muted" style={{ display: 'block', textAlign: 'left', marginTop: '2px', marginBottom: '2px' }}>
                                            Current: {tpdCurrentDescriptions[lang] || '—'}
                                        </small>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={tpdTranslations[lang] || ''}
                                            onChange={(e) => setTpdTranslations(prev => ({ ...prev, [lang]: e.target.value }))}
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                        {tpdSaveError && (
                            <div className="alert alert-danger mt-2">{tpdSaveError}</div>
                        )}
                        {tpdSaveSuccess && (
                            <div className="alert alert-success mt-2">{tpdSaveSuccess}</div>
                        )}
                        <div className="d-flex justify-content-end mt-3" style={{ gap: '8px' }}>
                            <button className="btn btn-primary" onClick={saveTPDTranslations} disabled={tpdSaving || tpdLoading}>
                                {tpdSaving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className="sr-only">Saving...</span>
                                    </>
                                ) : 'Save'}
                            </button>
                            <button className="btn btn-secondary" onClick={handleCloseTPDModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {activeTab === 'app1' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Add Supplier Pim Products in Webshop</h2>
                    <p>Will only add them if the product doesn't exist in webshop</p>
                    <textarea
                        className="form-control"
                        rows="10"
                        value={input1}
                        onChange={(e) => setInput1(e.target.value)}
                        placeholder="Paste suppliers and supplier codes here, separated by commas. Example: PFCONCEPT-IMPORT,102222"
                    />
                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={handleApp1Submit} disabled={loading1}>
                            {loading1 ? 'Processing...' : 'Submit'}
                        </button>
                    </div>
                    {loading1 && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${progress1}%` }}
                            >
                                {progress1.toFixed(0)}%
                            </div>
                        </div>
                    )}
                    <h3 className="text-center mb-4">Results</h3>
                    {results1.length > 0 ? (
                        <ul>
                            {results1.map((result, index) => (
                                <li key={index}>
                                    {result.supplier} - {result.supplierKode}: {result.status}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-center">No results to display. Please enter suppliers and supplier codes and click "Submit".</p>
                    )}
                </div>
            )}

            {activeTab === 'app2' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Optimize Products</h2>
                    <h5 className="text-center mb-1">Translate, set main category and activate products</h5>
                    <textarea
                        className="form-control"
                        rows="10"
                        value={productCodes}
                        onChange={(e) => setProductCodes(e.target.value)}
                        placeholder="Paste product codes here, one per line (you can add language parameter separated by comma). Example: 123456,de"
                    />
                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={optimizeProduct} disabled={loading2}>
                            {loading2 ? 'Processing...' : 'Process Codes'}
                        </button>
                    </div>
                    {loading2 && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${progress2}%` }}
                            >
                                {progress2.toFixed(0)}%
                            </div>
                        </div>
                    )}
                    <h2 className="text-center mb-4">Results</h2>
                    {results2.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                            <tr>
                                <th>Product Code</th>
                                <th>Category Name</th>
                                <th>Category ID</th>
                                <th>Update Status</th>
                                <th>Activation Status</th>
                                <th>Index Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {results2.map((result, index) => (
                                <tr key={index}>
                                    <td>{result.productCode}</td>
                                    <td>{result.categoryName}</td>
                                    <td>{result.categoryId}</td>
                                    <td>{result.updateStatus}</td>
                                    <td>{result.updateStatus3}</td>
                                    <td>{result.updateStatus4}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No results to display. Please enter product codes and click "Process Codes".</p>
                    )}
                </div>
            )}

            {activeTab === 'app2v2' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Optimize Products v2</h2>
                    <h5 className="text-center mb-1">Uses PXL NL product name as base for translation, then sets category, activates and indexes</h5>
                    <textarea
                        className="form-control"
                        rows="10"
                        value={productCodes2}
                        onChange={(e) => setProductCodes2(e.target.value)}
                        placeholder="Paste ZP product codes here, one per line"
                    />
                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={optimizeProduct2} disabled={loading2v2}>
                            {loading2v2 ? 'Processing...' : 'Process Codes'}
                        </button>
                    </div>
                    {loading2v2 && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${progress2v2}%` }}
                            >
                                {progress2v2.toFixed(0)}%
                            </div>
                        </div>
                    )}
                    <h2 className="text-center mb-4">Results</h2>
                    {results2v2.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                            <tr>
                                <th>Product Code</th>
                                <th>Complete All</th>
                                <th>PXL NL Name</th>
                                <th>Translation</th>
                                <th>Categories</th>
                                <th>Category Status</th>
                                <th>Activation</th>
                                <th>Index</th>
                            </tr>
                            </thead>
                            <tbody>
                            {results2v2.map((result, index) => (
                                <tr key={index}>
                                    <td>{result.productCode}</td>
                                    <td>{result.completeAllStatus}</td>
                                    <td>{result.pxlNameNl}</td>
                                    <td>{result.translateStatus}</td>
                                    <td>{result.categoryName}</td>
                                    <td>{result.categoryStatus}</td>
                                    <td>{result.activationStatus}</td>
                                    <td>{result.indexStatus}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No results to display. Please enter product codes and click "Process Codes".</p>
                    )}
                </div>
            )}

            {activeTab === 'app3' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Copy Products from Category</h2>
                    <textarea
                        className="form-control"
                        rows="1"
                        value={categoryPxl}
                        onChange={(e) => setCategoryPxl(e.target.value)}
                        placeholder="Enter the PXL category, ZAPRINTA category"
                    />
                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={handleCopyProductFromCategorySubmit} disabled={loading3}>
                            {loading3 ? 'Processing...' : 'Submit'}
                        </button>
                    </div>
                    {loading3 && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: '100%' }}
                            >
                                Processing...
                            </div>
                        </div>
                    )}
                    <h3 className="text-center mb-4">Results</h3>
                    {results3.length > 0 && (
                        <>
                            {/* Category Links */}
                            <div className="mb-3 text-center">
                                <div className="d-inline-block mr-3" style={{ marginRight: 12 }}>
                                    <label style={{ marginRight: 8 }}>ZAP Name language</label>
                                    <select
                                        className="form-control d-inline-block"
                                        style={{ width: 120, display: 'inline-block' }}
                                        value={zapNameLang}
                                        onChange={(e) => setZapNameLang(e.target.value)}
                                    >
                                        <option value="fr">FR</option>
                                        <option value="nl">NL</option>
                                        <option value="de">DE</option>
                                        <option value="es">ES</option>
                                        <option value="it">IT</option>
                                        <option value="en">EN</option>
                                        <option value="da">DA</option>
                                    </select>
                                </div>
                                {(() => {
                                    const first = results3[0] || {};
                                    const zapCatId = first.zap_cat_id;
                                    const pxlCatId = first.catId;
                                    return (
                                        <>
                                            {pxlCatId && (
                                                <LinkMenu
                                                    label="Promoxl Links"
                                                    subtitle={`#${pxlCatId}`}
                                                    items={[
                                                        { label: 'Open Webshop Category', url: `https://www.promo-xl.com/nl/category/${pxlCatId}` },
                                                        { label: 'Open Dashboard', url: `https://promoxl.compuzz.com/#webshop/categories/${pxlCatId}` }
                                                    ]}
                                                />
                                            )}
                                            {zapCatId && (
                                                <LinkMenu
                                                    label="Zaprinta Links"
                                                    subtitle={`#${zapCatId}`}
                                                    items={[
                                                        { label: 'Open Webshop Category', url: `https://www.zaprinta.fr/category/${zapCatId}` },
                                                        { label: 'Open Dashboard', url: `https://zaprinta.compuzz.com/#webshop/categories/${zapCatId}` }
                                                    ]}
                                                />
                                            )}
                                        </>
                                    );
                                })()}
                            </div>
                            <button className="btn btn-secondary mb-4" onClick={handleCopyResults}>
                                Copy Results to Clipboard
                            </button>
                            <table className="table table-striped">
                                <thead className="thead-dark">
                                <tr>
                                    <th>ZAP Code <button className="btn btn-sm btn-outline-secondary" title="Copy all ZAP codes with Optimize Product enabled" onClick={() => {
                                        const codes = results3
                                            .filter(r => r.zap_code && ((r.zap_status !== undefined && r.zap_status !== 1) || !r.zap_default_cat_code))
                                            .map(r => r.zap_code)
                                            .join('\n');
                                        navigator.clipboard.writeText(codes);
                                    }}>Copy Optimize</button></th>
                                    <th>ZAP Pic</th>
                                    <th>{`ZAP Name (${(zapNameLang || 'nl').toUpperCase()})`}</th>
                                    <th>PXL Code</th>
                                    <th>PXL Pic</th>
                                    <th>PXL Name</th>
                                    <th>TPN</th>
                                    <th>TPD</th>
                                    <th>Position</th>
                                    <th>Supplier</th>
                                    <th>Supplier Code</th>
                                    <th>Status</th>
                                    <th>ZAP Code + Position</th>
                                    <th>ADD to category <button className="btn btn-primary" onClick={(e) => clickAddAllProductsInCategory(results3)}>ADD ALL</button></th>
                                </tr>
                                </thead>
                                <tbody>
                                {results3.map((result, index) => (
                                    <tr key={index} id={`app3-row-${index}`} className={selectedRowIndex === index ? 'selected-row table-active' : ''}>
                                        <td style={{ color: (result.zap_status !== undefined && result.zap_status !== 1) || !result.zap_default_cat_code ? 'red' : 'inherit' }}>
                                            {result.zap_code ? (
                                                <>
                                                    <LinkMenu
                                                        label={result.zap_code}
                                                        subtitle=""
                                                        items={[
                                                            { label: 'Open on Webshop', url: `https://www.zaprinta.fr/product/${result.zap_code}` },
                                                            { label: 'Open in Dashboard', url: `${baseUrls.zaprintaUrl}/#webshop/products/${result.zap_id}` }
                                                        ]}
                                                    />
                                                    {((result.zap_status !== undefined && result.zap_status !== 1) || !result.zap_default_cat_code) && (
                                                        <button 
                                                            className="btn btn-sm btn-warning ml-2"
                                                            style={{ marginLeft: '8px' }}
                                                            onClick={() => optimizeSingleProduct(result.zap_code)}
                                                            disabled={optimizingProducts[result.zap_code]}
                                                        >
                                                            {optimizingProducts[result.zap_code] ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    <span className="sr-only">Optimizing...</span>
                                                                </>
                                                            ) : 'Optimize Product'}
                                                        </button>
                                                    )}
                                                </>
                                            ) : 'N/A'}
                                        </td>
                                        <td className="pictures-cell">
                                            {result.zap_image ? (
                                                <img src={buildFullImageUrl('https://www.zaprinta.fr/imgs/', result.zap_image)} alt={`ZP ${result.zap_code || ''}`} className="product-thumb" />
                                            ) : null}
                                        </td>
                                        <td title={getZapNameByLang(result)} style={{ maxWidth: '240px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {getZapNameByLang(result)}
                                        </td>
                                        <td>
                                            {result.code ? (
                                                <LinkMenu
                                                    label={result.code}
                                                    subtitle=""
                                                    items={[
                                                        { label: 'Open on Webshop', url: `https://www.promo-xl.com/nl/product/${result.code}` },
                                                        { label: 'Open in Dashboard', url: `${baseUrls.promoxlUrl}/#webshop/products/${result.id}` }
                                                    ]}
                                                />
                                            ) : 'N/A'}
                                        </td>
                                        <td className="pictures-cell">
                                            {result.pxl_image ? (
                                                <img src={buildFullImageUrl('https://d3ui177wzg1z54.cloudfront.net/', result.pxl_image)} alt={`PXL ${result.code || ''}`} className="product-thumb" />
                                            ) : null}
                                        </td>
                                        <td title={(result.namenl || result.pxl_name || result.name || '')} style={{ maxWidth: '240px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {result.namenl || result.pxl_name || result.name || 'N/A'}
                                        </td>
                                        <td>
                                            <button className="btn btn-sm btn-info" onClick={() => openTPNModal(result, index)}>TPN</button>
                                        </td>
                                        <td>
                                            <button className="btn btn-sm btn-warning" onClick={() => openTPDModal(result, index)}>TPD</button>
                                        </td>
                                        <td>{result.pos}</td>
                                        <td>{result.supplier}</td>
                                        <td>{result.supplier_code}</td>
                                        <td>{result.zap_status !== undefined ? result.zap_status : 'N/A'}</td>
                                        <td>{`${result.zap_code || 'N/A'},${((result.zap_pos !== null && result.zap_pos !== '') ? result.zap_pos : 'N/A')}`}</td>
                                        <td>
                                            {result.zap_code ? (
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => clickAddProductInCategory(result.zap_code, result.zap_cat_code, result.pos, true)}>ADD FIRST</button>
                                                    <button className="btn btn-primary" onClick={(e) => clickAddProductInCategory(result.zap_code, result.zap_cat_code, result.pos, false)}>ADD</button>
                                                </>
                                            ) : (
                                                <button 
                                                    className="btn btn-add-to-webshop" 
                                                    onClick={(e) => addProductToWebshop(result.supplier, result.supplier_code)}
                                                    disabled={loadingProducts[`${result.supplier}-${result.supplier_code}`]}
                                                >
                                                    {loadingProducts[`${result.supplier}-${result.supplier_code}`] ? 'ADDING...' : 'ADD TO WEBSHOP'}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </>
                    )}
                    {results3.length === 0 && (
                        <p className="text-center">No results to display. Please enter a category and click "Submit".</p>
                    )}
                </div>
            )}

            {activeTab === 'category' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Process Category Description</h2>
                    <p>Import category description</p>
                    <textarea
                        className="form-control"
                        rows="10"
                        value={input4}
                        onChange={(e) => setInput4(e.target.value)}
                        placeholder="Paste category code, keywords, locale (en-gb, nl-nl, fr-fr, fr-be, nl-be, de-be, de-at, de-de, it-it, es-es, nl-nl, da-dk, etc.), skipIfDone (true/false default = false), separated by commas. Example: 123456,keywords,en-gb,false"
                    />
                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={processCategory} disabled={loading4}>
                            {loading1 ? 'Processing...' : 'Submit'}
                        </button>
                    </div>
                    {loading4 && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${progress4}%` }}
                            >
                                {progress4.toFixed(0)}%
                            </div>
                        </div>
                    )}
                    <h3 className="text-center mb-4">Results</h3>
                    {results4.length > 0 ? (
                        <ul>
                            {results4.map((result, index) => (
                                <li key={index}>
                                    {result.categoryCode} - {result.keywords}: {result.score} {result.url}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-center">No results to display. data and click "Submit".</p>
                    )}
                </div>
            )}

            {activeTab === 'categoryMods' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Category Last Modification Dates</h2>
                    <p>This shows the last time products were modified in each category</p>

                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={fetchCategoryModifications} disabled={loadingCategoryMods}>
                            {loadingCategoryMods ? 'Loading...' : 'Refresh Data'}
                        </button>
                    </div>

                    {loadingCategoryMods && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: '100%' }}
                            >
                                Loading...
                            </div>
                        </div>
                    )}

                    <h3 className="text-center mb-4">Results</h3>
                    {categoryModifications.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Category Code</th>
                                    <th>Last Modified Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categoryModifications.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.code}</td>
                                        <td>{item.formattedDate}</td>
                                        <td>
                                            <button 
                                                className="btn btn-primary mr-2" 
                                                onClick={() => handleAddCategoryMatch(item.code)}
                                                disabled={processingCategory === item.code}
                                            >
                                                {processingCategory === item.code ? 'Processing...' : 'Add'}
                                            </button>
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={() => handleAddCategoryMatchNewTab(item.code)}
                                                disabled={processingCategory === item.code}
                                            >
                                                {processingCategory === item.code ? 'Processing...' : 'Add (New Tab)'}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No results to display. Click "Refresh Data" to fetch category modification dates.</p>
                    )}
                </div>
            )}
            {activeTab === 'priceModifications' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Product Price Modifications</h2>
                    <p>List of product codes with their last price modification date</p>

                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={fetchPriceModifications} disabled={loadingPriceModifications}>
                            {loadingPriceModifications ? 'Loading...' : 'Refresh Data'}
                        </button>
                    </div>

                    {loadingPriceModifications && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: '100%' }}
                            >
                                Loading...
                            </div>
                        </div>
                    )}

                    <h3 className="text-center mb-4">Results</h3>
                    {priceModifications.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Product Code</th>
                                    <th>Zaprinta Code</th>
                                    <th>Supplier</th>
                                    <th>Supplier Code</th>
                                    <th>Last Price Modification Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {priceModifications.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {item.productCode ? (
                                                <a 
                                                    href="#"
                                                    onClick={(e) => handleProductLinkClick(e, 'pxl', item.productCode, item.pxl_id)}
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    {item.productCode}
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td>
                                            {item.zap_code ? (
                                                <a 
                                                    href="#"
                                                    onClick={(e) => handleProductLinkClick(e, 'zp', item.zap_code, item.zap_id)}
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    {item.zap_code}
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td>{item.supplier || 'N/A'}</td>
                                        <td>{item.supplierCode || 'N/A'}</td>
                                        <td>{item.formattedDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No results to display. Click "Refresh Data" to fetch price modifications.</p>
                    )}
                </div>
            )}

            {activeTab === 'catalogPicModifications' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Catalog Picture Modifications</h2>
                    <p>List of products with their last catalog picture modification date</p>

                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary" onClick={fetchCatalogPicModifications} disabled={loadingCatalogPicModifications}>
                            {loadingCatalogPicModifications ? 'Loading...' : 'Refresh Data'}
                        </button>
                    </div>

                    {loadingCatalogPicModifications && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: '100%' }}
                            >
                                Loading...
                            </div>
                        </div>
                    )}

                    <h3 className="text-center mb-4">Results</h3>
                    {catalogPicModifications.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Account Code</th>
                                    <th>Product Code</th>
                                    <th>PXL Code</th>
                                    <th>Zaprinta Code</th>
                                    <th>Last Picture Modification Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {catalogPicModifications.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.accountCode}</td>
                                        <td>{item.productCode}</td>
                                        <td>
                                            {item.pxl_code ? (
                                                <a 
                                                    href="#"
                                                    onClick={(e) => handleProductLinkClick(e, 'pxl', item.pxl_code, item.pxl_id)}
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    {item.pxl_code}
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td>
                                            {item.zap_code ? (
                                                <a 
                                                    href="#"
                                                    onClick={(e) => handleProductLinkClick(e, 'zp', item.zap_code, item.zap_id)}
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    {item.zap_code}
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td>{item.formattedDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No results to display. Click "Refresh Data" to fetch catalog picture modifications.</p>
                    )}
                </div>
            )}

            {activeTab === 'categoryMatches' && (
                <div className="tab-content-section mt-4">
                    <h2 className="section-title">Category Matches Administration</h2>
                    <p>Manage the mapping between Promoxl (PXL) category codes and Zaprinta (ZP) category codes</p>

                    <div className="row">
                        <div className="col-md-6">
                            {/* Form to add a new category match */}
                            <div className="card mb-4">
                                <div className="card-header">
                                    <h3 className="mb-0">Add New Category Match</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={newPxlCode}
                                                onChange={(e) => setNewPxlCode(e.target.value)}
                                                placeholder="Enter PXL Code"
                                            />
                                        </div>
                                        <div className="col-md-5">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={newZpCode}
                                                onChange={(e) => setNewZpCode(e.target.value)}
                                                placeholder="Enter ZP Code (optional)"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <button 
                                                className="btn btn-primary w-100" 
                                                onClick={handleAddCategoryMatch2}
                                                disabled={loadingCategoryMatches}
                                            >
                                                {loadingCategoryMatches ? 'Adding...' : 'Add'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            {/* Form to upload CSV file */}
                            <div className="card mb-4">
                                <div className="card-header">
                                    <h3 className="mb-0">Upload CSV File</h3>
                                </div>
                                <div className="card-body">
                                    <p>Upload a CSV file with PXL and ZP code pairs to pre-fill the table.</p>
                                    <p className="text-muted small">CSV format: columns named "pxl_code" and "zp_code" (optional)</p>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <input
                                                id="csv-file-input"
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileSelect}
                                                accept=".csv"
                                                disabled={uploadingFile}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button 
                                                className="btn btn-primary w-100" 
                                                onClick={handleFileUpload}
                                                disabled={!selectedFile || uploadingFile}
                                            >
                                                {uploadingFile ? 'Uploading...' : 'Upload'}
                                            </button>
                                        </div>
                                    </div>

                                    {uploadingFile && (
                                        <div className="progress mt-3">
                                            <div
                                                className="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar"
                                                style={{ width: `${uploadProgress}%` }}
                                            >
                                                {uploadProgress}%
                                            </div>
                                        </div>
                                    )}

                                    {uploadResults && (
                                        <div className={`alert mt-3 ${uploadResults.success ? 'alert-success' : 'alert-danger'}`}>
                                            {uploadResults.success ? (
                                                <div>
                                                    <h4>Upload Successful</h4>
                                                    <p>Processed {uploadResults.processedRows} rows, {uploadResults.successfulRows} successful</p>
                                                    {uploadResults.errors.length > 0 && (
                                                        <div>
                                                            <p>Errors: {uploadResults.errors.length}</p>
                                                            <ul className="small">
                                                                {uploadResults.errors.slice(0, 5).map((error, index) => (
                                                                    <li key={index}>Row {error.row}: {error.error}</li>
                                                                ))}
                                                                {uploadResults.errors.length > 5 && <li>...and {uploadResults.errors.length - 5} more</li>}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div>
                                                    <h4>Upload Failed</h4>
                                                    <p>{uploadResults.error}</p>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mb-4 mt-4">
                        <button className="btn btn-primary me-2" onClick={fetchCategoryMatches} disabled={loadingCategoryMatches}>
                            {loadingCategoryMatches ? 'Loading...' : 'Refresh Data'}
                        </button>
                        <button className="btn btn-success" onClick={handleDownloadCategoryMatches} disabled={loadingCategoryMatches || categoryMatches.length === 0}>
                            Download as CSV
                        </button>
                    </div>

                    {loadingCategoryMatches && (
                        <div className="progress mb-4">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: '100%' }}
                            >
                                Loading...
                            </div>
                        </div>
                    )}

                    <h3 className="text-center mb-4">Category Matches</h3>
                    {categoryMatches.length > 0 ? (
                        <table className="table table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    <th>PXL Code</th>
                                    <th>ZP Code</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categoryMatches.map((match, index) => (
                                    <tr key={index}>
                                        <td>{match.pxl_code}</td>
                                        <td>
                                            {editingMatch === match.pxl_code ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue={match.zp_code || ''}
                                                    ref={(input) => input && input.focus()}
                                                    onBlur={(e) => {
                                                        if (e.target.value !== match.zp_code) {
                                                            handleUpdateCategoryMatch(match.pxl_code, e.target.value);
                                                        } else {
                                                            setEditingMatch(null);
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleUpdateCategoryMatch(match.pxl_code, e.target.value);
                                                        } else if (e.key === 'Escape') {
                                                            setEditingMatch(null);
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                match.zp_code || 'Not set'
                                            )}
                                        </td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-primary me-2" 
                                                onClick={() => setEditingMatch(match.pxl_code)}
                                                disabled={editingMatch === match.pxl_code}
                                            >
                                                Edit
                                            </button>
                                            <button 
                                                className="btn btn-sm btn-danger" 
                                                onClick={() => handleDeleteCategoryMatch(match.pxl_code)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center">No category matches found. Add a new match using the form above.</p>
                    )}
                </div>
            )}

            {activeTab === 'copyCategory' && (
                <div className="container mt-4">
                    <h3>Copy Category</h3>
                    <p>Enter ZP product codes (one per line). For each code, the system will find the matching PXL product, look up its category, map it to a ZP category, and add the product.</p>
                    <div className="form-group">
                        <textarea
                            className="form-control"
                            rows="6"
                            value={copyCategoryInput}
                            onChange={(e) => setCopyCategoryInput(e.target.value)}
                            placeholder="Enter ZP product codes, one per line"
                            disabled={copyCategoryLoading}
                        />
                    </div>
                    <button
                        className="btn btn-primary mt-2"
                        onClick={handleCopyCategorySubmit}
                        disabled={copyCategoryLoading || !copyCategoryInput.trim()}
                    >
                        {copyCategoryLoading ? 'Processing...' : 'Process Codes'}
                    </button>

                    {copyCategoryLoading && (
                        <div className="progress mt-3">
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${copyCategoryProgress}%` }}
                                aria-valuenow={copyCategoryProgress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {Math.round(copyCategoryProgress)}%
                            </div>
                        </div>
                    )}

                    {copyCategoryResults.length > 0 && (
                        <table className="table table-bordered mt-3">
                            <thead>
                                <tr>
                                    <th>ZP Code</th>
                                    <th>Supplier</th>
                                    <th>Supplier Code</th>
                                    <th>PXL Category</th>
                                    <th>ZP Category</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {copyCategoryResults.map((result, index) => (
                                    <tr key={index} style={{ backgroundColor: result.status === 'Success' ? '#d4edda' : '#f8d7da' }}>
                                        <td>{result.productCode || ''}</td>
                                        <td>{result.supplier || ''}</td>
                                        <td>{result.supplierCode || ''}</td>
                                        <td>{result.pxlCategory || ''}</td>
                                        <td>{result.zpCategory || ''}</td>
                                        <td>{result.status || ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}

            {/* Popup for entering Zaprinta code */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Enter Zaprinta Code</h3>
                        <p>No Zaprinta code found for category <strong>{currentPxlCode}</strong>. Please enter it below:</p>
                        <input
                            type="text"
                            className="form-control"
                            value={zpCodeInput}
                            onChange={(e) => setZpCodeInput(e.target.value)}
                            placeholder="Enter Zaprinta code"
                        />
                        <div className="popup-buttons">
                            <button className="btn btn-secondary" onClick={() => setShowPopup(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={handleSaveZpCode}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;
